<template>
  <div>
    <distributor />
    <supplier />
  </div>
</template>

<script>
import Distributor from "./DistributorInput";
import Supplier from "./SupplierInput";

export default {
  components: {
    Distributor,
    Supplier
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/parties/PartiesInput.vue